import React from 'react';

const HIGHLIGHTS = [
  {
    icon: '⚡',
    title: 'Senior UI Developer',
    desc: 'Crafting pixel-perfect, performant interfaces with React, Next.js and modern CSS.',
  },
  {
    icon: '🚀',
    title: 'Co-Founder · Korsha',
    desc: 'Founded and built Korsha — from concept, branding to full-stack delivery.',
  },
  {
    icon: '🏗️',
    title: 'End-to-End Builder',
    desc: 'React frontends + Node.js backends + cloud infra — full lifecycle ownership.',
  },
  {
    icon: '🎯',
    title: 'Solo Powerhouse',
    desc: '9+ years. 10+ shipped products. One engineer with zero compromises.',
  },
];

const About = () => (
  <section id="about">
    <div className="container about-inner">
      {/* Left */}
      <div>
        <span className="section-tag">About Me</span>
        <h2 className="section-title">
          POWERED BY<br />
          <span className="gradient-text">PURPOSE</span>
        </h2>
        <div className="glow-line" />
        <p className="about-para">
          Hey! I'm <strong>Suresh Narasimman</strong>, a Senior UI Developer and Co-Founder of{' '}
          <span style={{ fontFamily: "'Bebas Neue', sans-serif", letterSpacing: '.08em', color: 'var(--purple-light)' }}>
            KORSHA
          </span>{' '}
          — a tech studio where I blend creativity, engineering, and strategy to build
          end-to-end digital products that genuinely move the needle.
        </p>
        <p className="about-para">
          With <strong>9+ years of experience</strong>, I don't just write code — I architect experiences.
          From the first wireframe to production deployment, I take full ownership of every layer:
          design systems, React frontends, <strong>Node.js backends</strong>, cloud infrastructure,
          and everything in between.
        </p>
        <div className="about-cta-row">
          <a href="mailto:sureshsimmar@gmail.com" className="btn-primary">Get in Touch ↗</a>
        </div>
      </div>

      {/* Right */}
      <div>
        <div className="highlights-grid">
          {HIGHLIGHTS.map(({ icon, title, desc }) => (
            <div key={title} className="highlight-card glass-card">
              <span className="highlight-icon">{icon}</span>
              <div className="highlight-title">{title}</div>
              <div className="highlight-desc">{desc}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default About;
